//template:
// export const variableName = {
//     newhavenrace: [],
//     peavinerace: [],
//     wellsriverrumble: []
// }

export const galleryImages = {
    newhavenrace: [
        {
            src: 'scott_martin_013_1800.jpg',
            width: 1800,
            height: 1202,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_013_300.jpg', width: 300, height: 200 },
                { src: 'scott_martin_013_900.jpg', width: 900, height: 601 },
            ]
        },
        {
            src: 'scott_martin_010_1800.jpg',
            width: 1440,
            height: 1800,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_010_300.jpg', width: 240, height: 300 },
                { src: 'scott_martin_010_900.jpg', width: 720, height: 900 },
            ]
        },
        {
            src: 'scott_martin_001_1800.jpg',
            width: 1800,
            height: 1202,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_001_300.jpg', width: 300, height: 200 },
                { src: 'scott_martin_001_900.jpg', width: 900, height: 601 },
            ]
        },
        {
            src: 'scott_martin_002_1800.jpg',
            width: 1800,
            height: 1202,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_002_300.jpg', width: 300, height: 200 },
                { src: 'scott_martin_002_900.jpg', width: 900, height: 601 },
            ]
        },
        {
            src: 'scott_martin_003_1800.jpg',
            width: 1800,
            height: 1202,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_003_300.jpg', width: 300, height: 200 },
                { src: 'scott_martin_003_900.jpg', width: 900, height: 601 },
            ]
        },
        {
            src: 'scott_martin_004_1800.jpg',
            width: 1202,
            height: 1800,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_004_300.jpg', width: 200, height: 300 },
                { src: 'scott_martin_004_900.jpg', width: 601, height: 900 },
            ]
        },
        {
            src: 'scott_martin_005_1800.jpg',
            width: 1800,
            height: 1202,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_005_300.jpg', width: 300, height: 200 },
                { src: 'scott_martin_005_900.jpg', width: 900, height: 601 },
            ]
        },
        {
            src: 'scott_martin_006_1800.jpg',
            width: 1202,
            height: 1800,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_006_300.jpg', width: 200, height: 300 },
                { src: 'scott_martin_006_900.jpg', width: 601, height: 900 },
            ]
        },
        {
            src: 'caleb_kenna_001_1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Caleb Kenna',
            srcSet: [
                { src: 'caleb_kenna_001_300.jpg', width: 300, height: 200 },
                { src: 'caleb_kenna_001_900.jpg', width: 900, height: 600 },
            ]
        },
        {
            src: 'caleb_kenna_002_1800.jpg',
            width: 1800,
            height: 1201,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Caleb Kenna',
            srcSet: [
                { src: 'caleb_kenna_002_300.jpg', width: 300, height: 200 },
                { src: 'caleb_kenna_002_900.jpg', width: 900, height: 601 },
            ]
        },
        {
            src: 'caleb_kenna_003_1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Caleb Kenna',
            srcSet: [
                { src: 'caleb_kenna_003_300.jpg', width: 300, height: 200 },
                { src: 'caleb_kenna_003_900.jpg', width: 900, height: 600 },
            ]
        },
        {
            src: 'scott_martin_007_1800.jpg',
            width: 1202,
            height: 1800,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_007_300.jpg', width: 200, height: 300 },
                { src: 'scott_martin_007_900.jpg', width: 601, height: 900 },
            ]
        },
        {
            src: 'scott_martin_008_1800.jpg',
            width: 1202,
            height: 1800,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_008_300.jpg', width: 200, height: 300 },
                { src: 'scott_martin_008_900.jpg', width: 601, height: 900 },
            ]
        },
        {
            src: 'scott_martin_009_1800.jpg',
            width: 1800,
            height: 1202,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_009_300.jpg', width: 300, height: 200 },
                { src: 'scott_martin_009_900.jpg', width: 900, height: 601 },
            ]
        },
        {
            src: 'scott_martin_011_1800.jpg',
            width: 1202,
            height: 1800,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_011_300.jpg', width: 200, height: 300 },
                { src: 'scott_martin_011_900.jpg', width: 601, height: 900 },
            ]
        },
        {
            src: 'scott_martin_012_1800.jpg',
            width: 1800,
            height: 1202,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_012_300.jpg', width: 300, height: 200 },
                { src: 'scott_martin_012_900.jpg', width: 900, height: 601 },
            ]
        },
        {
            src: 'scott_martin_014_1800.jpg',
            width: 1440,
            height: 1800,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_014_300.jpg', width: 240, height: 300 },
                { src: 'scott_martin_014_900.jpg', width: 720, height: 900 },
            ]
        },
        {
            src: 'scott_martin_015_1800.jpg',
            width: 1202,
            height: 1800,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_015_300.jpg', width: 200, height: 300 },
                { src: 'scott_martin_015_900.jpg', width: 601, height: 900 },
            ]
        },
        {
            src: 'scott_martin_016_1800.jpg',
            width: 1440,
            height: 1800,
            alt: 'Picture of kayakers at the New Haven Whitewater Kayak Race in Bristol, Vermont',
            description: 'Photo credit Scott Martin',
            srcSet: [
                { src: 'scott_martin_016_300.jpg', width: 240, height: 300 },
                { src: 'scott_martin_016_900.jpg', width: 720, height: 900 }
            ]
        },
    ],
    peavinerace: [
        {
            src: 'kay_mccabe-01-1800.jpg',
            width: 1200,
            height: 1800,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-01-300.jpg',
                    width: 200,
                    height: 300,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-01-900.jpg',
                    width: 600,
                    height: 900,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
            ]
        },
        {
            src: 'kay_mccabe-02-1800.jpg',
            width: 1200,
            height: 1800,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-02-300.jpg',
                    width: 200,
                    height: 300,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-02-900.jpg',
                    width: 600,
                    height: 900,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
            ]
        },
        {
            src: 'kay_mccabe-03-1800.jpg',
            width: 1200,
            height: 1800,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-03-300.jpg',
                    width: 200,
                    height: 300,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-03-900.jpg',
                    width: 600,
                    height: 900,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-04-1800.jpg',
            width: 1200,
            height: 1800,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-04-300.jpg',
                    width: 200,
                    height: 300,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-04-900.jpg',
                    width: 600,
                    height: 900,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-05-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-05-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-05-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-06-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-06-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-06-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-07-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-07-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-07-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-08-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-08-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-08-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-09-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-09-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-09-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-10-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-10-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-10-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-11-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-11-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-11-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-12-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-12-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-12-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-13-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-13-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-13-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-14-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-14-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-14-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-15-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-15-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-15-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-16-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-16-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-16-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-17-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-17-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-17-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-18-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-18-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-18-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-19-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-19-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-19-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'kay_mccabe-20-1800.jpg',
            width: 1800,
            height: 1200,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Photo credit Kay McCabe',
            srcSet: [
                {
                    src: 'kay_mccabe-20-300.jpg',
                    width: 300,
                    height: 200,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                },
                {
                    src: 'kay_mccabe-20-900.jpg',
                    width: 900,
                    height: 600,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Photo credit Kay McCabe'
                }
            ]
        },
        {
            src: 'racers-photo-22-1800.jpg',
            width: 1800,
            height: 811,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Some of the racers from the 2022 event',
            srcSet: [
                {
                    src: 'racers-photo-22-300.jpg',
                    width: 300,
                    height: 135,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Some of the racers from the 2022 event',
                },
                {
                    src: 'racers-photo-22-900.jpg',
                    width: 900,
                    height: 405,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Some of the racers from the 2022 event'
                }
            ]
        },
        {
            src: 'racers-photo-23-1800.jpg',
            width: 1800,
            height: 1350,
            alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
            description: 'Some of the racers from the 2023 event',
            srcSet: [
                {
                    src: 'racers-photo-23-300.jpg',
                    width: 300,
                    height: 225,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Some of the racers from the 2023 event'
                },
                {
                    src: 'racers-photo-23-900.jpg',
                    width: 900,
                    height: 675,
                    alt: 'Picture of racers participating in the Peavine Whitewater Race on the White River, Vermont',
                    description: 'Some of the racers from the 2023 event',

                }
            ]
        },
    ],
    wellsriverrumble: []
} 

export const flagLookup = {
    canada: {
      "Alberta": "AB",
      "British Columbia": "BC",
      "Manitoba": "MB",
      "New Brunswick": "NB",
      "Newfoundland and Labrador": "NL",
      "Nova Scotia": "NS",
      "Ontario": "ON",
      "Prince Edward Island": "PE",
      "Quebec": "QC",
      "Saskatchewan": "SK",
      "Northwest Territories": "NT",
      "Nunavut": "NU",
      "Yukon": "YT"
    },
    unitedStates: {
      "Alabama": "AL",
      "Alaska": "AK",
      "Arizona": "AZ",
      "Arkansas": "AR",
      "California": "CA",
      "Colorado": "CO",
      "Connecticut": "CT",
      "Delaware": "DE",
      "Florida": "FL",
      "Georgia": "GA",
      "Hawaii": "HI",
      "Idaho": "ID",
      "Illinois": "IL",
      "Indiana": "IN",
      "Iowa": "IA",
      "Kansas": "KS",
      "Kentucky": "KY",
      "Louisiana": "LA",
      "Maine": "ME",
      "Maryland": "MD",
      "Massachusetts": "MA",
      "Michigan": "MI",
      "Minnesota": "MN",
      "Mississippi": "MS",
      "Missouri": "MO",
      "Montana": "MT",
      "Nebraska": "NE",
      "Nevada": "NV",
      "New Hampshire": "NH",
      "New Jersey": "NJ",
      "New Mexico": "NM",
      "New York": "NY",
      "North Carolina": "NC",
      "North Dakota": "ND",
      "Ohio": "OH",
      "Oklahoma": "OK",
      "Oregon": "OR",
      "Pennsylvania": "PA",
      "Rhode Island": "RI",
      "South Carolina": "SC",
      "South Dakota": "SD",
      "Tennessee": "TN",
      "Texas": "TX",
      "Utah": "UT",
      "Vermont": "VT",
      "Virginia": "VA",
      "Washington": "WA",
      "West Virginia": "WV",
      "Wisconsin": "WI",
      "Wyoming": "WY"
    }
  };
  
  
